export default "__VITE_ASSET__DZv2LqCU__"